import { Loading, Tooltip } from 'framework/ui/mui-builder';
import { PROJECT_TIMELINE_MESSAGE_CONTEXT } from '../../timeline/constants';
import { Stack, Typography } from '@mui/material';
import { ShowSection } from 'framework/ui/layout';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import RiskTimelineActionsButton from './RiskTimelineActionButton';
import EditNote from '@mui/icons-material/EditNote';
import useRiskNoteTimelineRegistry, { useRiskSystemNoteTimelineRegistry } from './useRiskNotesRegistry';
import { RisksType, UseRiskTimelineResult } from 'domain/shared/newProject';
import { useShowContext } from 'framework/show';
import PersonTimeline from 'domain/shared/timeline/person';

type RiskTimelineLayoutProps = {
  loading: boolean;
  refetch: UseRiskTimelineResult['refetch'];
  getTimelineItems: UseRiskTimelineResult['getTimelineItems'];
  getTimelinePageById: UseRiskTimelineResult['getTimelinePageById'];
  createTimelineItem: UseRiskTimelineResult['createTimelineItem'];
  pinTimelineAction: UseRiskTimelineResult['pinTimelineAction'];
};

const RiskTimelineLayout = ({
  loading,
  refetch,
  getTimelineItems,
  getTimelinePageById,
  createTimelineItem,
  pinTimelineAction,
}: RiskTimelineLayoutProps) => {
  const { data: showData } = useShowContext<RisksType>();
  const risk = showData?.getData();
  const entityId = risk?.id?.toString() ?? '';

  const noteRegistry = useRiskNoteTimelineRegistry({ refetch: () => refetch().then(() => {}) });
  const systemNoteRegistry = useRiskSystemNoteTimelineRegistry();

  const registries = [noteRegistry, systemNoteRegistry];

  const formConfig = {
    default: {
      icon: <EditNote />,
      text: 'New note',
    },
  };

  if (loading || !entityId) return <Loading isInitialPosition />;

  return (
    <ShowSection>
      <PersonTimeline
        timelineHeader={
          <Stack direction="row" alignItems="top">
            <Typography variant="h4" color="primary">
              Timeline
            </Typography>
            <Tooltip
              title={'Timeline notes are not included in the customer report, even if the risk is added to the report'}
              arrow
              placement="right"
            >
              <InfoIcon sx={{ color: 'text.secondary', fontSize: '15px' }} />
            </Tooltip>
          </Stack>
        }
        entityId={entityId}
        registries={registries}
        getTimelineItems={getTimelineItems}
        createTimelineItem={createTimelineItem}
        getTimelinePageById={getTimelinePageById}
        pinTimelineAction={pinTimelineAction}
        messageContext={PROJECT_TIMELINE_MESSAGE_CONTEXT}
        formConfig={formConfig}
        AddTimelineItemInput={RiskTimelineActionsButton}
        noEntriesMessage="No entries in this timeline yet."
      />
    </ShowSection>
  );
};

export default RiskTimelineLayout;
